import {NgModule} from "@angular/core";
import { FormsModule } from '@angular/forms';
import {ClientStatusComponent} from "./client-status.component";
import {ClientsService} from "../../models/clients/clients.service";
import {CommonModule} from "@angular/common";
import {AccountModalComponent} from "./account-modal/account-modal.component";


@NgModule({
    declarations: [
        ClientStatusComponent,
        AccountModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [
        ClientStatusComponent,
        AccountModalComponent
    ],
    providers: [
        ClientsService,
    ],
    entryComponents: [
        AccountModalComponent,
    ],
})

export class ClientStatusModule {

}


// WEBPACK FOOTER //
// ./src/app/modules/client-status/client-status.module.ts